import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import {
    ErrorDialogComponent,
    ErrorDialogData,
} from '../../shared/components/error-dialog/error-dialog.component';

@Injectable({
    providedIn: 'root',
})
export class ErrorDialogService {
    private readonly dialog = inject(MatDialog);
    private isOpen = false;

    show(message: string, title = 'Fehler'): void {
        if (this.isOpen) {
            return;
        }

        this.isOpen = true;

        this.dialog
            .open<ErrorDialogComponent, ErrorDialogData>(ErrorDialogComponent, {
                width: '420px',
                maxWidth: 'calc(100vw - 32px)',
                panelClass: 'role-dialog-panel',
                autoFocus: false,
                restoreFocus: false,
                data: {
                    title,
                    message,
                },
            })
            .afterClosed()
            .subscribe(() => {
                this.isOpen = false;
            });
    }
}